/**
 * Official UTMify tracking script loader.
 *
 * UTMify ships two separate scripts:
 *  1. latest.js  — UTM parameter capture / propagation. Needs no configuration.
 *  2. pixel.js   — the UTMify pixel. REQUIRES `window.pixelId` to be defined
 *                  BEFORE it loads. Without it the script resolves an empty
 *                  config and crashes with "undefined is not an object
 *                  (evaluating 'lead._id')".
 *
 * Set UTMIFY_PIXEL_ID below to enable the pixel. While it is empty, only the
 * UTM capture script loads, which is safe and self-sufficient.
 *
 * Safe to call multiple times — each script is injected only once.
 */

/** Paste your UTMify pixel ID here to activate the UTMify pixel. */
export const UTMIFY_PIXEL_ID = '';

const UTMS_SCRIPT_ID = 'utmify-utms-script';
const PIXEL_SCRIPT_ID = 'utmify-pixel-script';

declare global {
  interface Window {
    pixelId?: string;
  }
}

export function loadUtmify(): void {
  if (typeof document === 'undefined') return;

  // 1. UTM capture script (no configuration required).
  if (!document.getElementById(UTMS_SCRIPT_ID)) {
    const utms = document.createElement('script');
    utms.id = UTMS_SCRIPT_ID;
    utms.src = 'https://cdn.utmify.com.br/scripts/utms/latest.js';
    utms.async = true;
    utms.defer = true;
    utms.setAttribute('data-utmify-prevent-xcod-sck', '');
    utms.setAttribute('data-utmify-prevent-subid', '');
    document.head.appendChild(utms);
  }

  // 2. UTMify pixel — only load it when a pixel ID is configured.
  if (!UTMIFY_PIXEL_ID) return;
  if (document.getElementById(PIXEL_SCRIPT_ID)) return;

  window.pixelId = UTMIFY_PIXEL_ID;

  const pixel = document.createElement('script');
  pixel.id = PIXEL_SCRIPT_ID;
  pixel.src = 'https://cdn.utmify.com.br/scripts/pixel/pixel.js';
  pixel.async = true;
  pixel.defer = true;
  document.head.appendChild(pixel);
}
